/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BookingIdRemarkRuleCreateRequest,
    BookingIdRemarkRuleCreateRequestFromJSON,
    BookingIdRemarkRuleCreateRequestToJSON,
    BookingIdRemarkRuleFormConfiguration,
    BookingIdRemarkRuleFormConfigurationFromJSON,
    BookingIdRemarkRuleFormConfigurationToJSON,
    BookingIdRemarkRuleFormData,
    BookingIdRemarkRuleFormDataFromJSON,
    BookingIdRemarkRuleFormDataToJSON,
    BookingIdRemarkRuleFormDataBase,
    BookingIdRemarkRuleFormDataBaseFromJSON,
    BookingIdRemarkRuleFormDataBaseToJSON,
    BookingIdRemarkRuleUpdateRequest,
    BookingIdRemarkRuleUpdateRequestFromJSON,
    BookingIdRemarkRuleUpdateRequestToJSON,
    BookingIdRemarkRuleValidationData,
    BookingIdRemarkRuleValidationDataFromJSON,
    BookingIdRemarkRuleValidationDataToJSON,
} from '../models';

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormCreatePostRequest {
    bookingIdRemarkRuleCreateRequest?: BookingIdRemarkRuleCreateRequest;
}

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormDeleteDeleteRequest {
    id?: string;
}

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormGetByIdGetRequest {
    id?: string;
}

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormUpdatePostRequest {
    bookingIdRemarkRuleUpdateRequest?: BookingIdRemarkRuleUpdateRequest;
}

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormValidatePostRequest {
    bookingIdRemarkRuleFormDataBase?: BookingIdRemarkRuleFormDataBase;
}

/**
 * no description
 */
export class BookingIdRemarkRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormConfigurationGetRaw(): Promise<runtime.ApiResponse<BookingIdRemarkRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingIdRemarkRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormConfigurationGet(): Promise<BookingIdRemarkRuleFormConfiguration> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormCreatePostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingIdRemarkRuleCreateRequestToJSON(requestParameters.bookingIdRemarkRuleCreateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormCreatePost(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormCreatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormDeleteDeleteRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleForm/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormDeleteDelete(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormDeleteDeleteRequest): Promise<void> {
        await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormGetByIdGetRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormGetByIdGetRequest): Promise<runtime.ApiResponse<BookingIdRemarkRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingIdRemarkRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormGetByIdGet(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormGetByIdGetRequest): Promise<BookingIdRemarkRuleFormData> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormUpdatePostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingIdRemarkRuleUpdateRequestToJSON(requestParameters.bookingIdRemarkRuleUpdateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormUpdatePost(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormUpdatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormValidatePostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormValidatePostRequest): Promise<runtime.ApiResponse<BookingIdRemarkRuleValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingIdRemarkRuleFormDataBaseToJSON(requestParameters.bookingIdRemarkRuleFormDataBase),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingIdRemarkRuleValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormValidatePost(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormValidatePostRequest): Promise<BookingIdRemarkRuleValidationData> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
